

module.exports = __webpack_require__.stylable.create(
    "Card3407028041",
    {"classes":{"root":"Card3407028041__root","card":"Card3407028041__card","controls":"Card3407028041__controls"},"vars":{},"stVars":{},"keyframes":{}},
    ".Card3407028041__card{position:relative;background:#fff;border-radius:8px}.Card3407028041__card.Card3407028041--stretchVertically{height:100%;flex-grow:1}.Card3407028041__card.Card3407028041--hideOverflow{overflow:hidden}.Card3407028041__controls{position:absolute;top:0;right:0;padding:6px}.rtl .Card3407028041__controls,[dir=rtl] .Card3407028041__controls{left:0;right:auto}",
    2,
    "Card3407028041",
    __webpack_require__.stylable.$
);
